import { ILessonData } from "../../types/Lesson";
import { TextRenderer } from "../TextRenderer";

export function LessonText(props: { item: ILessonData }) {
  return <TextRenderer text={props.item.lesson.text_content} />;
}
